module.exports = __webpack_public_path__ + "img/tutorial_books_04.00c6665a.gif";